import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Check } from 'lucide-react';

const ThemeSelector: React.FC = () => {
  const { theme, setTheme, availableThemes } = useTheme();

  return (
    <div>
      <div style={{ fontSize: '11px', fontWeight: '700', color: '#6b7280', letterSpacing: '0.5px', marginBottom: '12px', textTransform: 'uppercase' }}>
        Select Theme
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '10px' }}>
        {availableThemes.map(({ key, name }) => (
          <div key={key} onClick={() => setTheme(key)}
            style={{ textAlign: 'center', cursor: 'pointer' }}>
            <div style={{
              width: '36px', height: '36px', borderRadius: '50%',
              background: getThemeGradient(key), margin: '0 auto 5px',
              position: 'relative', transition: 'all 0.15s',
              border: theme === key ? '2px solid #2563eb' : '2px solid transparent',
              boxShadow: theme === key ? '0 0 0 2px #bfdbfe, 0 2px 8px rgba(0,0,0,0.12)' : '0 1px 4px rgba(0,0,0,0.1)',
              transform: theme === key ? 'scale(1.12)' : 'scale(1)'
            }}>
              {theme === key && (
                <div style={{
                  position: 'absolute', inset: 0, display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  background: 'rgba(255,255,255,0.25)', borderRadius: '50%'
                }}>
                  <Check size={13} color="white" strokeWidth={3} />
                </div>
              )}
            </div>
            <div style={{
              fontSize: '10px', fontWeight: theme === key ? '700' : '500',
              color: theme === key ? '#2563eb' : '#6b7280', lineHeight: 1.2
            }}>
              {name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const getThemeGradient = (themeKey: string): string => {
  const gradients: Record<string, string> = {
    light: 'linear-gradient(135deg, #2563eb, #64748b)',
    dark: 'linear-gradient(135deg, #3b82f6, #1e293b)',
    blue: 'linear-gradient(135deg, #1e40af, #3b82f6)',
    green: 'linear-gradient(135deg, #16a34a, #22c55e)',
    purple: 'linear-gradient(135deg, #7c3aed, #a855f7)',
    gold: 'linear-gradient(135deg, #d97706, #f59e0b)',
    pink: 'linear-gradient(135deg, #e11d48, #f43f5e)',
    orange: 'linear-gradient(135deg, #ea580c, #fb923c)',
    blueaccent: 'linear-gradient(135deg, #0ea5e9, #38bdf8)',
    cyan: 'linear-gradient(135deg, #0891b2, #06b6d4)'
  };
  return gradients[themeKey] || gradients.light;
};

export default ThemeSelector;
